<template>
  <div>
    <v-dialog scrollable :value="value" @input="close()" width="800px">
      <v-card>
        <v-card-title class="grey lighten-4 py-4 title black--text">
          Payment for {{ data.provider.fullName }}
        </v-card-title>
        <v-card-text>
          <v-form v-model="Form.valid" enctype="multipart/form-data">
            <v-container grid-list-xs :class="$vuetify.breakpoint.mdAndUp ? 'pa-5' : ''">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    :value="numberUtil.commaWithDecimal(data.provider.total_unpaid)"
                    label="Total Earning"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <Upload label="Select Receipt" v-model="Form.image" required></Upload>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="pb-3 pr-5">
          <v-spacer></v-spacer>
          <v-btn text @click="close">Cancel</v-btn>
          <v-btn color="primary" text :disabled="!Form.valid" @click="payProvider">Pay</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Form from '../form/form';
import formMixin from '../Mixins/form';
import loader from '../utils/loader';
import providerService from '../services/providerProfiles';
import numberUtil from '../utils/number';
export default {
  provide() {
    return { parentValidator: this.$validator };
  },
  mixins: [formMixin],
  props: {
    value: Boolean,
    data: Object,
  },
  data() {
    return {
      Form: new Form({
        data() {
          return {
            image: null,
            valid: false,
          };
        },
      }),
    };
  },
  computed: {
    numberUtil() {
      return numberUtil;
    },
  },
  methods: {
    payProvider() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$root
            .$confirm('Pay', 'Are you confirm to pay?', {
              color: 'primary',
              submitText: 'Yes',
            })
            .then((confirm) => {
              if (confirm) {
                const formData = new FormData();
                formData.append('image', this.Form.image);
                if (this.data.month && this.data.year) {
                  formData.append('month', this.data.month);
                  formData.append('year', this.data.year);
                }
                providerService.payConfirmedTransactions(this.data.provider.id, formData).then(() => {
                  this.$notify({
                    title: 'Success',
                    text: 'Successfully paid provider.',
                    type: 'success',
                  });
                  this.close();
                  this.$emit('success');
                });
              }
            });
        }
      });
    },
    close() {
      this.resetFormError(null, this.Form);
      this.$emit('input', false);
    },
  },
  mounted() {},
  components: {
    Upload: loader.component('UploadFile'),
  },
};
</script>
